import { ModuleRegistry } from "seneca-common/features/module/registry";

import { markAnswer } from "./logic/answers";
import { getModuleAssets, transformModuleAssets } from "./logic/assets";
import { generateTextBlockContent } from "./logic/content";

export { transformModuleAssets };
export const MODULE_TYPE = "text-block";
export type TYPE = "text-block";

export const register = (moduleRegistry: ModuleRegistry) => {
  return moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateTextBlockContent)
    .getModuleAssets(getModuleAssets)
    .back.staticInformation()
    .displayName("Text Block")
    .readOnly()
    .root.register();
};
